const CodeInfo = Object.freeze({
  READY: 'READY',
  EXCEPTION: 'EXCEPTION',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
})

export default CodeInfo



// WEBPACK FOOTER //
// ./src/code/CodeInfo.js